import { render } from "./login-index.vue?vue&type=template&id=98f7df5a&scoped=true"
import script from "./login-index.vue?vue&type=script&lang=js"
export * from "./login-index.vue?vue&type=script&lang=js"

import "./login-index.vue?vue&type=style&index=0&id=98f7df5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98f7df5a"]])

export default __exports__